import type { RootState } from 'store/configureStore';

import {
  ACTION_TYPES,
  OpDefSelectorState,
  OpDefSelectorAction,
} from './actions';

const initialState: OpDefSelectorState = {
  hasInitiated: false,
  isLoading: false,
  opDefs: [],
};

const reducer = (
  state = initialState,
  action: OpDefSelectorAction,
): OpDefSelectorState => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_OP_DEFS_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case ACTION_TYPES.FETCH_OP_DEFS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ACTION_TYPES.FETCH_OP_DEFS_SUCCESS:
      return {
        ...state,
        hasInitiated: true,
        isLoading: false,
        opDefs: action.payload.opDefs,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: RootState): OpDefSelectorState =>
  state.modules.common.smartComponents.opDefSelector;

export const getHasInitiated = (state: RootState): boolean =>
  getScope(state).hasInitiated;

export const getIsLoading = (state: RootState): boolean =>
  getScope(state).isLoading;

export const getOpDefs = (state: RootState) => getScope(state).opDefs;
